/**
 * Infinity Collectables – Rotating Search Placeholder
 * Loaded via theme.liquid (deferred)
 */
(function () {
  'use strict';

  var phrases = [
    'Search for Funko Pop exclusives\u2026',
    'Search for Pok\u00e9mon booster packs\u2026',
    'Search for Anime figures\u2026',
    'Search for Loungefly bags\u2026',
    'Search for One Piece collectibles\u2026',
    'Search for Trading Card singles\u2026',
  ];

  var idx = 0;

  function applyPlaceholder() {
    var inputs = document.querySelectorAll(
      '.search-modal input[type="search"],' +
      ' predictive-search input[type="search"],' +
      ' input[type="search"].search__input,' +
      ' .field__input[type="search"]'
    );
    if (!inputs.length) return;
    inputs.forEach(function (input) {
      if (document.activeElement === input && input.value) return;
      input.setAttribute('placeholder', phrases[idx]);
    });
    idx = (idx + 1) % phrases.length;
  }

  function init() {
    applyPlaceholder();
    setInterval(applyPlaceholder, 2500);

    // Re-apply when search modal opens (Dawn uses <details>)
    document.addEventListener(
      'toggle',
      function (e) {
        if (e.target && e.target.matches('details')) {
          setTimeout(applyPlaceholder, 50);
        }
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
